import { z } from "zod";
import {
  YEAR,
  PDC_NO,
  PDC_AMOUNT,
  PDC_DATE,
  PDC_REMARKS,
  PDC_CHECK,
} from "./consts";

export const schema = z.object({
  [YEAR]: z.string().min(1, "This field is required"),
  [PDC_NO]: z.string().min(1, "This field is required"),
  [PDC_AMOUNT]: z.string().min(1, "This field is required"),
  [PDC_DATE]: z.string().min(1, "This field is required"),
  [PDC_REMARKS]: z.string().optional(),
  [PDC_CHECK]: z.boolean().optional(),
});

export type formValues = z.infer<typeof schema>;
